import { Provider } from "components/send-recept-data/SendReceptDataContext";
import { SendReceptDataList } from "components/send-recept-data/SendReceptDataList";

export const SendReceptDatas = () => {
    return (
        <Provider>
            <SendReceptDataList />
        </Provider>
    );
};
